import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Money({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M10.6666 18.6666V17.1084C10.2757 17.008 9.90318 16.8757 9.56834 16.7154C8.88073 16.3861 8.15955 15.8415 8.01098 15.0364L9.32219 14.7944C9.34906 14.9401 9.54893 15.2278 10.1442 15.5128C10.3045 15.5896 10.4801 15.6592 10.6666 15.7204V12.4954C10.2031 12.343 9.74806 12.1572 9.35469 11.9111C8.57562 11.4238 7.99992 10.6745 7.99992 9.52884C7.99992 8.61514 8.51514 7.91596 9.18362 7.45831C9.61364 7.16392 10.1257 6.95306 10.6666 6.82337V5.33331H11.9999V18.6666H10.6666ZM10.6666 8.20811V11.0791C10.4431 10.9901 10.2404 10.8925 10.0618 10.7808C9.59089 10.4862 9.33325 10.1265 9.33325 9.52884C9.33325 9.17502 9.51979 8.84402 9.93683 8.55852C10.1409 8.41884 10.3887 8.29989 10.6666 8.20811Z"
        fill={iconColor}
      />
      <Path
        d="M13.3333 17.2666C13.8056 17.1936 14.2611 17.0569 14.6609 16.8382C15.4448 16.4093 15.9999 15.6647 15.9999 14.5985C15.9999 14.0767 15.8601 13.6219 15.5973 13.2372C15.3402 12.8608 14.9895 12.5866 14.6184 12.3778C14.234 12.1616 13.7877 11.9956 13.3333 11.856V13.2598C13.5666 13.3437 13.778 13.4349 13.9648 13.5399C14.2186 13.6827 14.3889 13.832 14.4963 13.9893C14.5981 14.1383 14.6666 14.3275 14.6666 14.5985C14.6666 15.1179 14.4322 15.4434 14.021 15.6684C13.8274 15.7743 13.5947 15.8559 13.3333 15.9116V17.2666Z"
        fill={iconColor}
      />
      <Path
        d="M13.3333 6.82523V8.21094C13.9914 8.44431 14.4952 8.86454 14.7078 9.44062L15.9587 8.97899C15.5118 7.76808 14.466 7.10314 13.3333 6.82523Z"
        fill={iconColor}
      />
      <Path
        d="M11.9999 1.33331C6.10888 1.33331 1.33325 6.10894 1.33325 12C1.33325 17.891 6.10888 22.6666 11.9999 22.6666C17.891 22.6666 22.6666 17.891 22.6666 12C22.6666 6.10894 17.891 1.33331 11.9999 1.33331ZM2.66659 12C2.66659 6.84532 6.84526 2.66665 11.9999 2.66665C17.1546 2.66665 21.3333 6.84532 21.3333 12C21.3333 17.1546 17.1546 21.3333 11.9999 21.3333C6.84526 21.3333 2.66659 17.1546 2.66659 12Z"
        fill={iconColor}
      />
    </Svg>
  );
}
